import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Box, IconButton, Modal, Paper, Tooltip, withStyles } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { Label } from '../default'
import { acGetAllValidNotifications, acDeleteNotification } from '../../class/actions'
import { Loader, Alert, PrimaryButton } from '../default'

function RemoveNotificationModal({
    classes, open, onClose,
    notificationToBeRemoved, deleteNotificationError, deletingNotification
}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const removeNotification = notificationId => {

        dispatch(acDeleteNotification(notificationId))
            .then(() => {
                dispatch(acGetAllValidNotifications())
                    .catch(err => console.error(err))
                onClose()
            })
            .catch(err => console.error(err))

    }

    return (
        <Modal open={open} onClose={onClose} disableAutoFocus style={{ outline: 0 }}>
            <Paper
                square={true}
                className={classes.root + ' ' + classes.modalDiv}
            >
                <Box display='flex' alignItems='center' justifyContent='space-between'>
                    <Label v='h6'>
                        {t('modals.notifications.remove.title')}
                    </Label>
                    <Tooltip title={t('default.close')}>
                        <IconButton onClick={onClose}>
                            <Close />
                        </IconButton>
                    </Tooltip>
                </Box>

                <>
                    <div>
                        {
                            <Label v='body1'>
                                {t('modals.notifications.remove.text', { id: notificationToBeRemoved.id })}
                            </Label>
                        }
                        {
                            deleteNotificationError && (
                                <Alert style={{ marginTop: '15px' }} noMargin color="error" text={t('modals.notifications.remove.error')} />
                            )
                        }
                    </div>
                    <div style={{ marginTop: '15px' }}>
                        <PrimaryButton onClick={() => removeNotification(notificationToBeRemoved.id)} style={{ width: '100%' }}>
                            {
                                deletingNotification ? (
                                    <Loader />
                                ) : (
                                    t('modals.notifications.remove.confirmButton')
                                )
                            }
                        </PrimaryButton>
                    </div>
                </>
            </Paper>
        </Modal>
    )
}

RemoveNotificationModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    close: PropTypes.func
}

RemoveNotificationModal.defaultProps = {
    open: false,
    onClose: () => true,
}

const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        padding: theme.spacing(2),
    },
    modalDiv: {
        [theme.breakpoints.up('md')]: {
            width: '35%'
        },
        width: '100%',
        top: '10%',
        left: '50%',
        transform: 'translate(-50%, -10%)',
    }
})

const mapStateToProps = ({ ReducerNotification }) => ({
    deleteNotificationError: ReducerNotification.deleteNotificationError,
    deletingNotification: ReducerNotification.deletingNotification
})

export default connect(mapStateToProps)(withStyles(styles)(RemoveNotificationModal))
